module.exports = __webpack_public_path__ + "assets/maestro-5ca10d.svg";